import Vue from 'vue'

import uiChart from './src/ui-chart.vue';


Vue.component(uiChart.extendOptions.name, uiChart);


export default uiChart;



//////////////////
// WEBPACK FOOTER
// ./~/ui-chart/index.js
// module id = 543
// module chunks = 0